import React from 'react';
import { COLOR_BY_REQUEST_STATUS } from 'components/Requests/styles';
import { StyledAccordion } from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/MyRequests/styles';
import RequestDetails from 'components/Requests/RequestDetails';
import { StyledShortBody14 } from 'components/Refunds/styles';
import { translate } from 'helpers/intl';
import { get } from 'lodash';
import { useIntl } from 'react-intl';
import {
  DossiersType,
  listDossierType,
} from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/MyRequests';
import messages from './messages';

interface RequestsType {
  requests: DossiersType;
  expanded: boolean | String;
  handleChange: Function;
  listIndex: Number;
  isLoading: boolean;
}

const AccordionSinistre = ({
  requests,
  listIndex,
  handleChange,
  expanded,
  isLoading,
}: RequestsType) => {
  const intl = useIntl();

  const renderDetails = (item: listDossierType, index: Number) => {
    return (
      <RequestDetails
        request={item}
        isLoading={isLoading}
        expanded={expanded}
        index={`request-${listIndex}-item-${index}`}
      />
    );
  };

  return (
    <>
      {Object.keys(requests)
        .reverse()
        .map((item: string) => {
          return (
            <>
              <StyledShortBody14>{`${translate(get(messages, 'year'), {
                intl,
              })} ${item}`}</StyledShortBody14>
              {
                /* istanbul ignore next */ requests[item]?.map(
                  (request: listDossierType, index: number) => {
                    return (
                      <StyledAccordion
                        color={
                          COLOR_BY_REQUEST_STATUS[request.Statut] ||
                          COLOR_BY_REQUEST_STATUS.DEFAULT
                        }
                        aria-controls={`panel-content-${index}`}
                        id={`panel-header-${index}`}
                        data-testid={`request-item-${index}`}
                        onChange={handleChange(
                          `request-${listIndex}-item-${index}`,
                          request.NumDeclaration,
                        )}
                        expanded={
                          expanded === `request-${listIndex}-item-${index}`
                        }
                      >
                        {renderDetails(request, index)}
                      </StyledAccordion>
                    );
                  },
                )
              }
            </>
          );
        })}
    </>
  );
};

export default AccordionSinistre;
